import React, { FC, ReactNode } from 'react';
import PrimaryButton from '../buttons/PrimaryButton';
import SecondaryButton from '../buttons/SecondaryButton';

interface IButton {
  text: string | ReactNode;
  onClick: () => void;
  disabled?: boolean;
  className?: string;
}

interface IContainer {
  children: ReactNode;
  primaryBtn?: IButton & { btnType?: 'outline' | 'link' };
  secondaryBtn?: IButton & { btnType?: 'default' | 'outline' };
  'data-testid'?: string;
  className?: string;
}

const Container: FC<IContainer> = props => {
  const { children, primaryBtn, secondaryBtn, className } = props;
  return (
    <div data-testid={props['data-testid']} className="w-full h-full flex flex-col justify-between">
      <main className={`px-6 pt-6 pb-36 sm:pb-6 w-full grow ${className}`}>{children}</main>
      {(primaryBtn || secondaryBtn) && (
        <div className="grid grid-flow-row gap-y-2 sm:gap-0 sm:grid-cols-auto sm:grid-flow-col w-full p-4 sm:pb-6 sm:pt-0 sm:px-6 bg-white border-t sm:border-0 border-gray-300 fixed sm:static bottom-0 left-0 sm:justify-between">
          {primaryBtn && <PrimaryButton {...primaryBtn}>{primaryBtn.text}</PrimaryButton>}
          {secondaryBtn && (
            <SecondaryButton
              {...secondaryBtn}
              className={`border-none order-last sm:order-none sm:px-0! ${secondaryBtn.className}`}
            >
              {secondaryBtn.text}
            </SecondaryButton>
          )}
        </div>
      )}
    </div>
  );
};

export default Container;
